import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'

import './flags.css'
import './style.css'

import en from './en.json'
import lt from './lt.json'
import pl from './pl.json'

import PrimeVue from 'primevue/config'
import FocusTrap from 'primevue/focustrap'
import ToastService from 'primevue/toastservice'
import App from './App.vue'
import prime from './prime'
;(async () => {
    const cargoElement = document.getElementById('cargo')
    const currentLang = window.location.pathname.split('/')[1]

    const mainData = JSON.parse(
        cargoElement?.dataset.main ||
            '{"from": "", "to": "", "fromCode": "", "toCode": "", "embed": false, "lang": "en", "fromZip": "", "toZip": ""}'
    )

    const { lang, embed } = mainData

    const app = createApp(App)
    const pinia = createPinia()

    const i18n = createI18n<[typeof en], 'en' | 'lt' | 'pl'>({
        legacy: false,
        locale: currentLang !== '' ? currentLang : lang,
        messages: { en, lt, pl }
    })

    const head = createHead()

    if (!embed) {
        const embedLang = currentLang !== '' ? currentLang : lang
        const localeMeta = i18n.global.getLocaleMessage(embedLang).meta

        head.push({
            title: localeMeta.title,
            meta: [
                { name: 'description', content: () => localeMeta.description },
                { property: 'og:url', content: 'https://app.fromtocargo.com/' + embedLang + '/' },
                { property: 'og:type', content: 'website' },
                { property: 'og:title', content: localeMeta.title },
                { property: 'og:description', content: () => localeMeta.description },
                { property: 'og:image', content: 'https://app.fromtocargo.com/preview.png' },
                { name: 'twitter:card', content: 'summary_large_image' },
                { property: 'twitter:domain', content: 'app.fromtocargo.com' },
                { property: 'twitter:url', content: 'https://app.fromtocargo.com/' + embedLang + '/' },
                { name: 'twitter:title', content: localeMeta.title },
                { name: 'twitter:description', content: () => localeMeta.description },
                { name: 'twitter:image', content: 'https://app.fromtocargo.com/preview.png' }
            ]
        })
    }

    pinia.use(({ store }) => {
        store.main = markRaw(mainData)
    })

    app.use(pinia)
    app.use(i18n)
    app.use(head)

    app.use(PrimeVue, prime)
    app.use(ToastService)
    app.directive('focustrap', FocusTrap)

    app.mount('#cargo')
})()
